// ScheduleDemo.js
import React, { use, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Grid, FormControl, InputLabel, Select, MenuItem, DialogContentText, Divider, IconButton, Icon } from '@mui/material';
import { IconCheck, IconX } from '@tabler/icons-react';
import { useForm } from 'react-hook-form';
import dayjs from "dayjs";
import axios from 'axios';
import { BeatLoader } from 'react-spinners';
import Cookies from 'js-cookie';
const ScheduleDemo = forwardRef(({ showBanner }, ref) => {
    const [visible, setVisible] = useState(showBanner);
    // const userInfo = JSON.parse(Cookies.get('user-info'))
    const [userInfo, setuserInfo] = useState(() => {
      const cookieData = Cookies.get('user-info');
      return cookieData ? JSON.parse(cookieData) : null;
    });
   useEffect(() => {
     const interval = setInterval(() => {
       const cookieData = Cookies.get('user-info');
       const userinfo = cookieData ? JSON.parse(cookieData) : null;
       setuserInfo(userinfo);
     }, 1000); 
   
     return () => clearInterval(interval); 
   }, []);
    const [open, setopen] = useState(false)
    const [loader, setloader] = useState(false)
    const [scheduledDateTime, setScheduledDateTime] = useState(dayjs())
    const [selectedZone, setSelectedZone] = useState("Asia/Kolkata");
    const [Success, setSuccess] = useState(false)
    const { register, handleSubmit, reset, formState: { errors }, trigger, setValue } = useForm();
    useImperativeHandle(ref, () => ({
        openDialog: () => setopen(true),
    }));
    const onSubmit = async (data) => {
        setloader(true)
        try {
            const config2 = {
                headers: {
                    Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
                },
            };
            let req =
            {
                ticket_desc: "I would like to schedule a demo of your software solution to understand its features and capabilities.",
                user_email: data.email,
                employee_number: userInfo?.id,
                user_name: data.name,
                company_name: data.companyName,
                id: userInfo?.id,
                demo_shedule_date: data.scheduledDateTime,
                demo_shedule_time_zone: selectedZone,
                is_demo_ticket: 1
            }
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/create_ticket/`, req, config2)
            if (response.status === 201) {
                setopen(false)
                setloader(false)
                setSuccess(true)
            }
        } catch (err) {
            setloader(false)
            console.log(err);
        }
    };
    const timeZones = [
        {
            value: "Asia/Kolkata",
            label: "Asia/Kolkata",
            offset: "GMT+5:30"
        },
        {
            value: "America/New_York",
            label: "America/New_York",
            offset: "GMT-5:00"
        },
        {
            value: "Europe/London",
            label: "Europe/London",
            offset: "GMT+0:00"
        },
        {
            value: "Asia/Tokyo",
            label: "Asia/Tokyo",
            offset: "GMT+9:00"
        }
        // add more as needed
    ];
    const GetData = async () => {
        try {
            const response = await axios.get('/apiV1/get-profile/');
            if (response.status === 200) {
                console.log(response.data.message);
                setValue('email', response?.data?.message?.email)
                setValue('mobile', response?.data?.message?.mobile)
                setValue('companyName', response?.data?.message?.company_name)
                setValue('name', response?.data?.message?.fullname)
                setValue("companywebsite", response?.data?.message?.company_website)
            }
        } catch (error) {
            console.error("Error fetching profile data:", error.response ? error.response.data : error.message);
        }
    };
    const handleChangetime = (event) => {
        setScheduledDateTime(event.target.value);
    };
    const handleZoneChange = (event) => {
        setSelectedZone(event.target.value);
    };
    const [minDateTime, setMinDateTime] = useState("");

    useEffect(() => {
        const now = new Date();
        const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16);
        setMinDateTime(localISOTime);
    }, []);
    const [setupdata, setsetupdata] = useState()
    const [visibledemo, setVisibledemo] = useState(false);
    const getSetupData = async () => {
        try {
            setloader(true)
            const response = await axios.get('/apiV1/set-up/')
            if (response.status === 200) {
                setsetupdata(response.data)
                setloader(false)
                setTimeout(() => {
                    setVisibledemo(true);
                }, 1000)

            }
        }
        catch (err) {
            setloader(false)
            console.log(err?.response?.data?.message);

        }
    }
    useEffect(() => {
        getSetupData();
    }, []);
    if (!visible || (setupdata?.is_subscribed && !setupdata?.is_guest)) return null;

    return (
        <>
            {visibledemo && (
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: "14%",
                        right: 0,
                        bgcolor: '#076599',
                        zIndex: 1000,
                        maxWidth: "40%",
                        margin: 'auto',
                        padding: 1,
                        mb: 0.5,
                        borderRadius: '8px',
                        textAlign: 'center',
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1} justifyContent="space-between">
                        <Typography variant="body2" color="#fff" ml={1}>
                            Schedule a demo call with our Product experts
                            <span
                                style={{
                                    fontWeight: 'bold',
                                    textDecoration: "underline",
                                    marginLeft: "10px",
                                    cursor: "pointer"
                                }}
                                onClick={() => { setopen(true); GetData() }}
                            >
                                Request a demo
                            </span>.
                        </Typography>
                        <Box sx={{ cursor: "pointer" }}>
                            <IconX onClick={() => setVisible(false)} color='#fff' />
                        </Box>
                    </Box>
                </Box>
            )}

            <Dialog open={open} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" fontWeight="bold">
                            Schedule a Demo
                        </Typography>
                        <IconButton onClick={() => { setopen(false); reset() }}><IconX /></IconButton>
                    </Box>
                </DialogTitle>
                <Divider />

                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            {/* Name */}
                            <Grid item xs={6}>
                                <FormControl fullWidth sx={{ mb: 1 }}>
                                    <Typography variant="body2" sx={{ mb: 1 }}>Full Name <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                    <TextField
                                        placeholder="Enter Name"
                                        {...register("name", {
                                            required: "Full Name is required",
                                            validate: value =>
                                                value.trimStart() === value || "Full Name should not start with a space",
                                            pattern: {
                                                value: /^[a-zA-Z\s]+$/,
                                                message: "Full Name should contain only letters and spaces",
                                            },
                                        })}
                                        error={!!errors.name}
                                        helperText={errors.name?.message}
                                        onKeyUp={() => trigger("name")}
                                        disabled={loader}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Email */}
                            <Grid item xs={6}>
                                <FormControl fullWidth sx={{ mb: 1 }}>
                                    <Typography variant="body2" sx={{ mb: 1 }}>Email <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                    <TextField
                                        type="email"
                                        fullWidth
                                        variant="outlined"
                                        disabled
                                        {...register('email', {
                                            required: 'Email is required',
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: 'Invalid email address',
                                            },
                                        })}
                                        error={!!errors.email}
                                        helperText={errors.email?.message}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Company */}
                            <Grid item xs={6}>
                                <FormControl fullWidth sx={{ mb: 1 }}>
                                    <Typography variant="body2" sx={{ mb: 1 }}>Company Name <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                    <TextField
                                        placeholder='Enter Company Name'
                                        fullWidth
                                        variant="outlined"
                                        {...register('companyName', {
                                            required: "Company Name is Required"
                                        })}
                                        error={!!errors.companyName}
                                        helperText={errors.companyName?.message}
                                        onKeyUp={() => trigger("companyName")}
                                    />
                                </FormControl>

                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth sx={{ mb: 1 }}>
                                    <Typography variant="body2" sx={{ mb: 1 }}>Company Website</Typography>
                                    <TextField
                                        placeholder="Enter Website Name"
                                        fullWidth
                                        variant="outlined"
                                        {...register('companywebsite', {
                                            pattern: {
                                                value: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/,
                                                message: "Invalid URL address",
                                            },
                                        })}
                                        error={!!errors.companywebsite}
                                        helperText={errors.companywebsite?.message}
                                        onKeyUp={() => trigger("companywebsite")}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Phone */}
                            <Grid item xs={6}>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <Typography variant="body2" sx={{ mb: 1 }}>Mobile <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                    {/* <TextField
                                        placeholder="Enter Mobile"
                                        {...register("mobile", {
                                            required: "Mobile Number is required",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Only numeric values are allowed",
                                            },
                                            minLength: {
                                                value: 10,
                                                message: "Mobile number must be at least 10 digits",
                                            },
                                            maxLength: {
                                                value: 12,
                                                message: "Mobile number must not exceed 12 digits",
                                            },
                                        })}
                                        error={!!errors.mobile}
                                        helperText={errors.mobile?.message}
                                        onKeyUp={() => trigger("mobile")}
                                        disabled={loader}
                                        inputProps={{
                                            maxLength: 12,
                                        }}
                                    /> */}
                                    <TextField
                                        placeholder="Enter Mobile"
                                        {...register("mobile", {
                                            required: "Mobile Number is required",
                                            pattern: {
                                                value: /^(?! )[+0-9()\-\s]{8,20}$/,
                                                message: "Enter a valid number (no space at start, allow +()- and digits)",
                                            },
                                            minLength: {
                                                value: 8,
                                                message: "Mobile number must be at least 8 characters",
                                            },
                                            maxLength: {
                                                value: 20,
                                                message: "Mobile number must not exceed 20 characters",
                                            },
                                        })}
                                        error={!!errors.mobile}
                                        helperText={errors.mobile?.message}
                                        onKeyUp={() => trigger("mobile")}
                                        disabled={loader}
                                        inputProps={{
                                            maxLength: 20,
                                            inputMode: "tel",
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <Typography variant="body2" sx={{ mb: 1 }}>Schedule Date & Time <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                    <TextField
                                        id="birthdaytime"
                                        name="birthdaytime"
                                        type="datetime-local"
                                        // label="Schedule Date & Time"
                                        // value={scheduledDateTime}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ min: minDateTime }}
                                        {...register("scheduledDateTime", { required: "Schedule Date & Time is required." })}
                                        error={Boolean(errors.scheduledDateTime)}
                                        helperText={errors.scheduledDateTime?.message}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    Select Time Zone <span style={{ color: "red", fontSize: "15px" }}>*</span>
                                </Typography>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <Select
                                        labelId="timezone-label"
                                        id="timezone"
                                        value={selectedZone}
                                        onChange={handleZoneChange}
                                        required
                                        sx={{
                                            height: "2.6rem",
                                            "& .MuiSelect-select": {
                                                height: "1rem",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    >
                                        {timeZones.map((zone) => (
                                            <MenuItem key={zone.value} value={zone.value}>
                                                {`${zone.offset} ${zone.label} (${zone.offset})`}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>


                        </Grid>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => { setopen(false); reset() }} variant="outlined" disabled={loader}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" className='button2' disabled={loader}>
                            {loader ? <BeatLoader color='#fff' /> : "Request a Demo"}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>


            <Dialog
                open={Success}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setSuccess(false);
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="xs"
                sx={{ textAlign: "center" }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
                    Success
                </DialogTitle>

                <Divider />

                <DialogContent>
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                        <IconButton
                            disableRipple
                            sx={{
                                backgroundColor: "#0e860e",
                                padding: 3,
                                "&:hover": { backgroundColor: "#0e860e" }
                            }}
                        >
                            <IconCheck color="#fff" size={30} />
                        </IconButton>
                    </Box>

                    <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
                        Your demo has been scheduled successfully. Our team will reach out soon with further details
                    </DialogContentText>
                </DialogContent>

                <Divider />

                <DialogActions>
                    <Button
                        onClick={() => { setSuccess(false) }}
                        sx={{
                            olor: "#fff",
                            fontSize: "16px",
                            fontWeight: "bold",
                            borderRadius: "8px",
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
});

export default ScheduleDemo;
